import { _ as __wbg_init, a1 as exports } from './index.js';

const module = new URL("aleo_wasm.wasm", import.meta.url);

                async function init(options) {
                    await __wbg_init({
                        module_or_path: await options.module,
                        memory: options.memory,
                    });
                    return exports;
                }

export { init, module };
//# sourceMappingURL=aleo_wasm_custom.js.map
